import { useState } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import CompanyWorkAreaChecks from '../company/CompanyWorkAreaChecks'
import Button from '../../atoms/inputs/Button'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'

type Props = {
  open: boolean
  onChange: (ids: string[]) => void
  onClose: () => void
}

export default function ClientSearchAreaSelectDialog({ open, onChange, onClose }: Props) {
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const handleSetting = () => {
    onChange(selectedIds)
    onClose()
  }
  return (
    <Dialog title="対応可能地域の選択" open={open} width="lg" onClose={onClose}>
      <FlexColumn scroll={false}>
        <FlexColumn height="calc(100vh - 240px)" scroll>
          <CompanyWorkAreaChecks areaIds={selectedIds} onChange={setSelectedIds} />
        </FlexColumn>
        <FlexRow justify="flex-end">
          <Button onClick={handleSetting}>設定</Button>
        </FlexRow>
      </FlexColumn>
    </Dialog>
  )
}
